import React from 'react';
import './GameStatsTab.scss';
import DynamicIframe from '../Common/DynamicIframe';

const GameStatsTab = ({ matchDetails }) => {
  const statsV2BaseUrl =
    process.env.REACT_APP_API_PATH === 'https://dev.api.sketchbball.com'
      ? 'https://dev.stats.sketchbball.com/v2/embed/matches'
      : 'https://stats.sketchbball.com/v2/embed/matches';

  const match_id = matchDetails?.match_id;

  // Don't render if match_id is missing
  if (!match_id) {
    return null;
  }

  const statsV2_query_params =
    'lang=en_US&isDebug=false&showMatchFlow=true&showShotFrequency=true&showScoreBoard=false&showTeamStat=true&showHeadToHead=false&showBoxScore=false&showPlayByPlay=false&showTitle=true&isFixed=true&background=f6f6f6&maxWidth=100%&frequencyMode=all';
  const statsV2_url = `${statsV2BaseUrl}/${match_id}?${statsV2_query_params}`;

  return (
    <div className='game-stats-tab'>
      <div className='game-stats-header'>
        <h3>Advanced Game Statistics</h3>
        <p>Comprehensive match analysis with advanced metrics and visualizations</p>
      </div>

      <div className='game-stats-container'>
        <DynamicIframe url={statsV2_url} className='game-stats-iframe' />
      </div>
    </div>
  );
};

export default GameStatsTab;
